import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import {
  correspondenceQueryKeys,
  CorrespondenceThreadRoute,
} from "toptaal-shared"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { CorrespondenceEntityType } from "toptaal-shared"
import { checkPermissions } from "@/utils/checkPermissions"
import { can } from "@/utils/can"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/correspondentie/$threadId",
)({
  component: RouteComponent,
  beforeLoad: async () => {
    return checkPermissions("read", "studentCorrespondence")
  },
})

function RouteComponent() {
  const router = useRouter()
  const { studentId: studentIdParam, threadId: threadIdParam } = useParams({
    from: "/beheer/cursisten/$studentId/correspondentie/$threadId",
  })
  const { data: user } = useCurrentUserSuspenseQuery()

  const entityType: CorrespondenceEntityType = "Student"
  const threadId = Number(threadIdParam)
  const entityId = Number(studentIdParam)

  const handleNavigateBack = () => {
    router.navigate({
      to: `/beheer/cursisten/${studentIdParam}/correspondentie`,
    })
  }

  return (
    <CorrespondenceThreadRoute
      threadId={threadId}
      entityType={entityType}
      entityId={entityId}
      user={user.data}
      correspondenceQueryKeys={correspondenceQueryKeys}
      onNavigateBack={handleNavigateBack}
      canCreateCorrespondence={can("create", "studentCorrespondence")}
    />
  )
}
